import { Modal, Table } from "react-bootstrap";

function DetailModal({ close, parts = [] }) {
  return (
    <Modal show={true} onHide={close} centered={true} size="xl">
      <Modal.Header>
        <h5>جزئیات</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="w-100 px-1 overflow-x-auto">
          <Table>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>نام مرسوله</th>
                <th>ارزش اظهار شده کالا</th>
                <th>برند</th>
              </tr>
            </thead>
            <tbody>
              {parts.map((item, idx) => (
                <tr key={item.id}>
                  <td>{idx + 1}</td>
                  <td>{item.shipment}</td>
                  <td>{item.value}</td>
                  <td>{item.brand}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger" onClick={close}>
          بستن
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DetailModal;
